import React, { Component } from 'react';
import WaitingStatus from '../Components/WaitingStatus/WaitingStatus';

class WaitingApp extends Component {
  render() {
    return <WaitingStatus {...this.props} />;
  }
}

export default WaitingApp;
